import React from 'react';
import Edit from '../../../containers/rest/Edit';
import Form from '../components/Form';

const GuaranteesEdit = props => (
  <Edit {...props} resource="guarantees">
    <Form />
  </Edit>
);

GuaranteesEdit.propTypes = {};

export default GuaranteesEdit;
